import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useAuthApi } from "./authApi";

const AuthServiceContext = createContext();

const AuthService = ({ children }) => {
  const navigate = useNavigate();
  const api = useAuthApi();
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [authToken, setAuthToken] = useState(null);
  const [user] = useState(null);
  const [send, setSend] = useState(false);
  const [captchaState, setCaptchaState] = useState({
    ask: false,
    token: "",
  });
  const [error, setError] = useState(null);

  const login = async (credentials) => {
    try {
      setLoading(true);
      const response = await api.post("/Users/Authenticate", credentials);

      const { data } = response;
      setLoading(false);
      if (data.success) {
        //setAuthToken(data.token);
        Cookies.set("Token", data.token);
        setAuthenticated(true);
        if (!data.auth2FaEnabled) navigate("/packages");

        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const auth2Factor = async (credentials) => {
    try {
      setLoading(true);
      const response = await api.post("/Users/Auth2Fa", credentials);

      const { data } = response;
      if (data.success) {
        //setAuthToken(data.token);
        //Cookies.set("Token", data.token);
        setLoading(false);
        setAuthenticated(true);
        navigate("/packages");
      }
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const logout = async () => {
    try {
      setLoading(true);
      await api.get("/Users/LogOut");
      setLoading(false);
      Cookies.remove("Token");
      setAuthenticated(false);
      navigate("/auth-signin");
    } catch (error) {
      setError(error);
    }
  };

  const checkPersonalId = async (personalId) => {
    try {
      const response = await api.post("/Users/CheckPersonalId", {
        info: personalId,
      });

      const { data } = response;
      return data.success;
    } catch (error) {
      setError(error);
    }
  };

  const checkUsername = async (username) => {
    try {
      const response = await api.post("/Users/CheckUsername", {
        info: username,
      });

      const { data } = response;
      return data.success;
    } catch (error) {
      setError(error);
    }
  };

  const sendSms = async (formData) => {
    try {
      const response = await api.post(
        "/DeliveryOrders/SmsPinRequest",
        formData
      );
      const { data } = response;

      return data.message;
    } catch (error) {
      setError(error);
    }
  };

  const register = async (credentials) => {
    //console.log(credentials);
    try {
      const response = await api.post("/Users/Register", credentials);
      //console.log(response);
      const { data } = response;
      //console.log(data);
      if (data.success) {
        //setAuthToken(data.token);
        Cookies.set("Token", data.token);
        //setAuthenticated(true);
        navigate("/packages");
      } else {
        return response.data;
      }
    } catch (error) {
      setError(error);
      console.log(error);
    }
  };

  const resetPasswordRequest = async (formData) => {
    try {
      setLoading(true);
      const response = await api.post("/Users/ResetPasswordRequest", formData);
      const { data } = response;
      setLoading(false);
      return data;
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const resetPassword = async (formData) => {
    try {
      setLoading(true);
      const response = await api.post("/Users/ResetPassword", formData);
      const { data } = response;
      setLoading(false);
      return data;
    } catch (error) {
      setError(error);
    }
  };

  return (
    <AuthServiceContext.Provider
      value={{
        authenticated,
        user,
        error,
        captchaState,
        send,
        loading,
        setCaptchaState,
        login,
        logout,
        register,
        checkPersonalId,
        checkUsername,
        setSend,
        sendSms,
        auth2Factor,
        resetPasswordRequest,
        resetPassword,
      }}
    >
      {children}
    </AuthServiceContext.Provider>
  );
};

export { AuthServiceContext, AuthService };
